import { ActionsUnion, createAction } from "common/reducers/UtilsTypes";
import { Nullable } from "common/types";

export const SET_TOKENS = "@auth/SET_TOKENS";
export const SET_TOKEN = "@auth/SET_TOKEN";
export const SET_AUTHENTICATING = "@auth/SET_AUTHENTICATING";
export const SET_ACCESS_UID = "@auth/SET_ACCESS_UID";
export const SET_REFRESH_TOKEN_EXPIRED = "@auth/SET_REFRESH_TOKEN_EXPIRED";
export const SET_AUTHENTICATED = "@auth/SET_AUTHENTICATED";

export type LoginPayload = { email: string; password: string };
export type AuthTokens = { token: Nullable<string>; refreshToken: Nullable<string> };

export const AuthActions = {
  setTokens: (tokens: AuthTokens) => createAction(SET_TOKENS, tokens),
  setToken: (token: string) => createAction(SET_TOKEN, token),
  setAccessUid: (uid: string) => createAction(SET_ACCESS_UID, { uid }),
  setAuthenticating: (authing: boolean) => createAction(SET_AUTHENTICATING, authing),
  setRefreshTokenExpired: (refreshToken: boolean) => createAction(SET_REFRESH_TOKEN_EXPIRED, refreshToken),
  setAuthenticated: (authenticated: boolean) => createAction(SET_AUTHENTICATED, authenticated),
};
export type AuthActions = ActionsUnion<typeof AuthActions>;
